import { render, staticRenderFns } from "./recursos-sgsst.vue?vue&type=template&id=4c6e4f7a&scoped=true&"
import script from "./recursos-sgsst.vue?vue&type=script&lang=js&"
export * from "./recursos-sgsst.vue?vue&type=script&lang=js&"
import style0 from "./recursos-sgsst.vue?vue&type=style&index=0&id=4c6e4f7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e4f7a",
  null
  
)

export default component.exports